const Home = () => import('@/views/dash/settings/busine/HomeBusine.vue')
const Info = () => import('@/views/dash/settings/busine/DataBusine.vue')
const Invoices = () => import('@/views/dash/settings/busine/InvoicesBusine.vue')
const SeeInvoice = () => import('@/views/dash/settings/busine/SeeInvoice.vue')
const openingHours = () => import('@/views/dash/settings/busine/AccessControl.vue')

export default [

    {
        path: 'empresa',
        name: 'busine',
        component: Home,
        meta: { title: 'empresa', permission: 2 },
        children: [
            { path: '', name: 'busine.info', component: Info, meta: { title: 'Empresa'}},
            { path: 'faturas', name: 'busine.invoices', component: Invoices, meta: { title: 'Faturas'}},
            { path: 'faturas/:id', name: 'busine.seeinvoice', component: SeeInvoice, meta: { title: 'Ver Fatura'}},
            { path: 'horario-de-funcionamento', name: 'busine.openingHours', component: openingHours, meta: { title: 'Horário de funcionamento'}},
        ],
    },
]